module.exports = __webpack_public_path__ + "img/eze_nms_logo.6bfbbebb.svg";